import React from 'react';

const Loader = ({ list }) => {
    return (
        <div class='loader-box' style={{ position:'fixed' }}>
            <span class='loader'></span>
        </div>
    );
};

export default Loader;
